import { SHADES_SIZE, SHADES_SMALL_SIZE } from '../constants';
import { ShadeSize } from '../types';
export const getShadeRootSize = (size, border) => {
  const shadeRootSize = size === ShadeSize.Medium ? SHADES_SIZE : SHADES_SMALL_SIZE;
  const shadeRootSizeWithBorder = border === undefined ? shadeRootSize : shadeRootSize - 2;
  return `${shadeRootSizeWithBorder}px`;
};
//# sourceMappingURL=getShadeRootSize.js.map